import Vue from 'vue'
import moment from 'moment-timezone'
import api from '@/services/api'

export const state = () => ({
  isMigrated: false,
  appPlatform: 'WEBSITE',
  currentPageID: '',
  currentPageName: '',
  myProfilePageName: '',
  universityList: [],
  cameraModalOwnerRef: null,
  cameraImageData: {},
  currentAdminVerifyMember: null,
  occupancyRate: null,
  occupancyRateLastSynced: 0
})
export const getters = {
  isMigrated (state) {
    return state.isMigrated
  },
  appPlatform (state) {
    return state.appPlatform
  },
  currentPageID (state) {
    return state.currentPageID
  },
  currentPageName (state) {
    return state.currentPageName
  },
  myProfilePageName (state) {
    return state.myProfilePageName
  },
  universityList (state) {
    return state.universityList
  },
  cameraModalOwnerRef (state) {
    return state.cameraModalOwnerRef
  },
  cameraImageData (state) {
    return state.cameraImageData
  },
  currentAdminVerifyMember (state) {
    return state.currentAdminVerifyMember
  },
  occupancyRate (state) {
    return state.occupancyRate
  },
  occupancyRateLastSynced (state) {
    return state.occupancyRateLastSynced
  }
}
export const actions = {
  SET_IS_MIGRATED ({ commit }) {
    commit('IS_MIGRATED_SET', true)
  },
  SET_APP_PLATFORM ({ commit }, appPlatform) {
    return new Promise((resolve) => {
      commit('APP_PLATFORM_SET', appPlatform)
      resolve()
    })
  },
  SET_CURRENT_PAGE ({ commit }, pageName) {
    return new Promise((resolve) => {
      commit('CURRENT_PAGE_CHANGED', pageName)
      resolve()
    })
  },
  SET_CURRENT_PAGE_ID ({ commit }, pageID) {
    return new Promise((resolve) => {
      commit('CURRENT_PAGE_ID_CHANGED', pageID)
      resolve()
    })
  },
  SET_MY_PROFILE_CURRENT_PAGE ({ commit }, pageName) {
    return new Promise((resolve) => {
      commit('CURRENT_MY_PROFILE_PAGE_CHANGED', pageName)
      resolve()
    })
  },
  GET_EDUCATION_INSTITUTES ({ commit }) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .getEducationInstitutes()
        .then((list) => {
          commit('GET_EDUCATION_INSTITUTES_COMPLETED', list)
          resolve(list)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  ADMIN_SELECT_VERIFY_USER ({ commit }, member) {
    return new Promise((resolve) => {
      commit('ADMIN_VERIFY_USER_SELECTED', member)
      resolve(member)
    })
  },
  OPEN_CAMERA_MODAL ({ commit }, ref) {
    return new Promise((resolve) => {
      commit('CAMERA_MODAL_OPENED', ref)
      resolve()
    })
  },
  CLOSE_CAMERA_MODAL ({ commit }) {
    return new Promise((resolve) => {
      commit('CAMERA_MODAL_CLOSED')
      resolve()
    })
  },
  STORE_CAMERA_IMAGE ({ commit }, { ref, data }) {
    return new Promise((resolve) => {
      commit('CAMERA_IMAGE_STORED', { ref, data })
      resolve()
    })
  },
  SUBMIT_CONTACT (ctx, payload) {
    return new Promise((resolve, reject) => {
      api(this.app.context)
        .submitContact(payload)
        .then((result) => {
          resolve(result)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  GET_OCCUPANCY_RATE ({ state, commit }) {
    return new Promise((resolve, reject) => {
      const lastSynced = moment(state.occupancyRateLastSynced).tz(this.app.context.env.TIMEZONE)
      console.log('lastSynced', lastSynced)
      const now = moment().tz(this.app.context.env.TIMEZONE)
      if (!lastSynced.isValid() || now.diff(lastSynced, 'minute') > 5) {
        api(this.app.context)
          .getOccupancyRate()
          .then((result) => {
            commit('GET_OCCUPANCY_RATE_COMPLETED', {
              lastSynced: now.format('X'),
              result
            })
            resolve(result)
          }).catch((e) => {
            reject(e)
          })
      } else {
        resolve(state.occupancyRate)
      }
    })
  }
}
export const mutations = {
  IS_MIGRATED_SET (state, isMigrated) {
    state.isMigrated = isMigrated
  },
  APP_PLATFORM_SET (state, appPlatform) {
    state.appPlatform = appPlatform
  },
  CURRENT_PAGE_CHANGED (state, pageName) {
    state.currentPageName = pageName
  },
  CURRENT_PAGE_ID_CHANGED (state, pageID) {
    state.currentPageID = pageID
  },
  CURRENT_MY_PROFILE_PAGE_CHANGED (state, pageName) {
    state.myProfilePageName = pageName
  },
  GET_EDUCATION_INSTITUTES_COMPLETED (state, list) {
    state.universityList = list
  },
  ADMIN_VERIFY_USER_SELECTED (state, member) {
    state.currentAdminVerifyMember = member
  },
  CAMERA_MODAL_OPENED (state, ref) {
    state.cameraModalOwnerRef = ref
  },
  CAMERA_MODAL_CLOSED (state) {
    state.cameraModalOwnerRef = null
  },
  CAMERA_IMAGE_STORED (state, { ref, data }) {
    Vue.set(state.cameraImageData, ref, data)
  },
  GET_OCCUPANCY_RATE_COMPLETED (state, { lastSynced, result }) {
    state.occupancyRateLastSynced = lastSynced
    state.occupancyRate = result
  }
}
